import { FC, ReactNode } from 'react';
import { Avatar, Card, CardProps, Stack, Typography } from '@mui/material';
import DownloadIllustration from '@assets/illustrations/download-spreadsheet.png';
import { ReactComponent as FillIllustration } from '@assets/illustrations/fill-spreadsheet.svg';
import { ReactComponent as UploadIllustration } from '@assets/illustrations/upload-spreadsheet.svg';

export interface IBulkUploadStepCardProps extends Omit<CardProps, 'title'> {
	step: 'download' | 'fill' | 'upload';
	title?: ReactNode;
	subtitle?: ReactNode;
}

const StepMap: Record<IBulkUploadStepCardProps['step'], number> = {
	download: 1,
	fill: 2,
	upload: 3
};

const IllustrationMap: Record<IBulkUploadStepCardProps['step'], any> = {
	download: <img src={DownloadIllustration} style={{ minWidth: 72 }} />,
	fill: <FillIllustration style={{ minWidth: 72 }} />,
	upload: <UploadIllustration style={{ minWidth: 72 }} />
};

export const BulkUploadStepCard: FC<IBulkUploadStepCardProps> = ({ step, title, subtitle, sx, ...props }) => {
	return (
		<Card
			variant="outlined"
			sx={{ paddingY: 2.5, paddingLeft: 6, paddingRight: 5, width: 600, borderColor: 'grey.200', ...sx }}
			{...props}
		>
			<Stack direction="row" alignItems="center" spacing={4}>
				<Avatar
					sx={{
						width: 52,
						height: 52,
						bgcolor: 'transparent',
						color: 'common.black',
						borderStyle: 'solid',
						borderWidth: 3,
						borderColor: 'common.black',
						fontSize: 28,
						fontWeight: 600
					}}
				>
					{StepMap[step]}
				</Avatar>
				<Stack direction="column" flexGrow={1}>
					{title && <Typography variant="h5">{title}</Typography>}
					{subtitle && <Typography>{subtitle}</Typography>}
				</Stack>
				{IllustrationMap[step]}
			</Stack>
		</Card>
	);
};
